import React from 'react';
import { Box } from '@chakra-ui/react';

const DataCard = ({ children, p = 0, overflow = 'hidden', ...props }) => (
  <Box
    bg="white"
    borderRadius="2xl"
    border="1px solid"
    borderColor="slate.100"
    boxShadow="soft"
    overflow={overflow}
    p={p}
    {...props}
  >
    {children}
  </Box>
);

export default DataCard;
